const INITIALIZE_STATES = "INITIALIZE_STATES";
const SET_APPLICATION = "SET_APPLICATION";
const SET_DRAWER = "SET_DRAWER";
const SET_DRAWER_RIGHT = "SET_DRAWER_RIGHT";
const SET_VISIBLE_JUMP = "SET_VISIBLE_JUMP";
const SET_VISIBLE_OPTIONS = "SET_VISIBLE_OPTIONS";
const SET_USES_APP_TABS = "SET_USES_APP_TABS";
const SET_USES_MODAL_JUMP = "SET_USES_MODAL_JUMP";
const SET_USES_SIDEBAR_IMAGE = "SET_USES_SIDEBAR_IMAGE";
const SET_DIALOG_TOOLBAR_STYLE = "SET_DIALOG_TOOLBAR_STYLE";
const SET_COMMAND_COLOR = "SET_COMMAND_COLOR";
const SET_COMMAND_BUTTONS_TEXT_STYLE = "SET_COMMAND_BUTTONS_TEXT_STYLE";
const SET_COMMAND_BUTTONS_OUTLINED = "SET_COMMAND_BUTTONS_OUTLINED";
const SET_TOOLBAR_DETAILS_COLOR = "SET_TOOLBAR_DETAILS_COLOR";
const SET_TABLE_SCROLL = "SET_TABLE_SCROLL";

export {
  SET_TABLE_SCROLL,
  INITIALIZE_STATES,
  SET_APPLICATION,
  SET_DRAWER,
  SET_DRAWER_RIGHT,
  SET_VISIBLE_JUMP,
  SET_VISIBLE_OPTIONS,
  SET_USES_APP_TABS,
  SET_USES_MODAL_JUMP,
  SET_USES_SIDEBAR_IMAGE,
  SET_DIALOG_TOOLBAR_STYLE,
  SET_COMMAND_COLOR,
  SET_COMMAND_BUTTONS_TEXT_STYLE,
  SET_COMMAND_BUTTONS_OUTLINED,
  SET_TOOLBAR_DETAILS_COLOR
};
